import React from 'react';

import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import _ from 'lodash';

class ShootFlagDropdown extends React.Component {
	constructor() {
		super();
		this.state = {
			showFlagDropdown: false,
		};
		this.dropdownref = React.createRef();
		this.wrapper = React.createRef();
	}

	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		if (
			this.dropdownref.current &&
			!this.dropdownref.current.contains(event.target) &&
			this.wrapper.current &&
			!this.wrapper.current.contains(event.target)
		) {
			this.setState({
				showFlagDropdown: false,
			});
		}
	};

	toggleFlagDropDown = () => {
		this.setState({
			showFlagDropdown: !this.state.showFlagDropdown,
		});
	};

	render() {
		return (
			<div
				ref={this.dropdownref}
				className={
					'shoot-dropdown-btn-container' +
					(this.state.showFlagDropdown === true ? ' open' : '')
				}
				onClick={(e) => {
					e.stopPropagation();
					this.toggleFlagDropDown();
				}}
			>
				<span
					className={
						'left-flag' +
						(this.props.flag === 'red'
							? ' flag-red'
							: this.props.flag === 'green'
							? ' flag-green'
							: this.props.flag === 'yellow'
							? ' flag-yellow'
							: '')
					}
				></span>
				<span className="right-icon">
					<DownIcon />
				</span>
				{this.state.showFlagDropdown ? (
					<div className="search-dropdown shoot-flag-dropdown" ref={this.wrapper}>
						{_.map(this.props.flagList, (item, index) => {
							return (
								<a
									className={
										'item' + (this.props.flag === item.value ? ' active' : '')
									}
									onClick={(e) => {
										e.stopPropagation();
										if (this.props.flag !== item.value)
											this.props.onFlagSelected(item.value);
									}}
								>
									<span
										className={
											'shoot-flag' +
											(item.value === 'red'
												? ' flag-red'
												: item.value === 'green'
												? ' flag-green'
												: item.value === 'yellow'
												? ' flag-yellow'
												: '')
										}
									></span>
								</a>
							);
						})}
						{this.props.flag !== null ? (
							<a
								style={{
									borderTop: '2px solid #b0b0b0',
								}}
								className={'item'}
								onClick={(e) => {
									e.stopPropagation();

									this.props.onFlagSelected(null);
								}}
							>
								Reset
							</a>
						) : null}
					</div>
				) : (
					''
				)}
			</div>
		);
	}
}

export default ShootFlagDropdown;
